import axios from './axiosConfig';
const BASE_URL = '/consumer';

export const login = async (data) => {
    const response = await axios.post('/auth/login', data);
    const token = response.data.token;
    if (token) {
        localStorage.setItem('Token', token);
    }
    return response;
};

export const getConsumers = async (page, pageSize) => {
    const res = await axios.get(
        `${BASE_URL}?page=${page}&pageSize=${pageSize}`
    );

    if (res.data.success) {
        return res.data.data; // { data, currentPage, totalItems, totalPages }
    }
    throw new Error(res.data.message);
};

export const registerConsumer = async (data) => {
    debugger;
    const response = await axios.post(`${BASE_URL}/register`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    const { success, message, data: resultData } = response.data;
    if (success) {
        return response.data;
    } else {
        throw new Error(message || 'Registration failed');
    }
};

export const updateConsumer = async (id, data) => {
    const response = await axios.put(`${BASE_URL}/update/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    const { success, message, data: resultData } = response.data;
    if (success) {
        return response.data;
    } else {
        throw new Error(message || 'Update failed');
    }
};

export const deleteConsumer = (id, data) =>
    axios.delete(`${BASE_URL}/delete/${id}`, { data });

export const resetPassword = (payload) =>
    axios.post(`/user/reset-password`, payload);


export const openConsumerPdf = async (id, type) => {
    try {
        const response = await axios.get(`${BASE_URL}/pdf/${id}?type=${type}`, {
            responseType: 'blob',
        });

        const blob = response.data; // <-- axios gives blob here directly
        const contentDisposition = response.headers['content-disposition'];
        let filename = "download.pdf";

        // Extract filename if available
        if (contentDisposition) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match && match[1]) {
                filename = match[1].replace(/['"]/g, '');
            }
        }

        // Create and trigger download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading PDF:", error);
        alert("Failed to download PDF");
    }
};

export const getConsumerSummary = async () => {
    const res = await axios.get(`${BASE_URL}/summary`);
    return res.data.data; // ✅ return ONLY dashboard data
};
